(function () {
  if (window.__tdUpsellCascade) return;
  window.__tdUpsellCascade = true;

  var origFetch = window.fetch;
  var cleaning = false;

  function refreshCart() {
    var hasUpcart = typeof window.upcartRefreshCart === 'function';
    if (hasUpcart) window.upcartRefreshCart();
    if (typeof window.upcartUpdateCart === 'function') window.upcartUpdateCart();
    // Native theme drawer: no app to re-render it. Refresh in place, never open —
    // this runs as a background reconciliation after orphaned lines are removed,
    // so popping a drawer open would be wrong. No-op while UpCart is installed.
    if (!hasUpcart && typeof window.tdRefreshCartDrawer === 'function') {
      try { window.tdRefreshCartDrawer(false); } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('upcart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('tastydose:cart-updated', { detail: { source: 'upsell-cascade' } }));
  }

  function buildUpdates(cart) {
    var items = (cart && cart.items) || [];
    if (!items.length) return null;
    var parentHandles = {};
    items.forEach(function (li) { parentHandles[li.handle] = true; });

    var upsellLines = items.filter(function (li) {
      var p = li.properties || {};
      return !!p._upsell_for;
    });
    if (!upsellLines.length) return null;

    var updates = {};
    var keepKey = null;

    upsellLines.forEach(function (li) {
      var p = li.properties || {};
      if (!parentHandles[p._upsell_for]) {
        updates[li.key] = 0;
      } else if (keepKey === null) {
        keepKey = li.key;
        if (li.quantity > 1) updates[li.key] = 1;
      } else {
        updates[li.key] = 0;
      }
    });

    return Object.keys(updates).length ? updates : null;
  }

  // Bundle upsell source records (td-upsell-popup.js recordBundleSource) live as
  // cart attributes `_upsell_bundle_<variantId>`. Cart attributes outlive the
  // line (and even /cart/clear.js), so drop any whose bundle variant is no
  // longer in the cart; otherwise a later organic purchase of the same bundle
  // would be reported as a popup sale.
  function buildAttrPrune(cart) {
    var attrs = (cart && cart.attributes) || {};
    var items = (cart && cart.items) || [];
    var present = {};
    items.forEach(function (li) { present[String(li.variant_id)] = true; });
    var prune = null;
    Object.keys(attrs).forEach(function (k) {
      var m = /^_upsell_bundle_(\d+)$/.exec(k);
      if (m && !present[m[1]]) {
        prune = prune || {};
        prune[k] = null;
      }
    });
    return prune;
  }

  function cleanupFromCart(cart) {
    var updates = buildUpdates(cart);
    var prune = buildAttrPrune(cart);
    if (!updates && !prune) return;
    var body = {};
    if (updates) body.updates = updates;
    if (prune) body.attributes = prune;
    cleaning = true;
    return origFetch.call(window, '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        cleaning = false;
        if (updates) refreshCart(); // attribute-only prune changes nothing visible
      })
      .catch(function (err) {
        cleaning = false;
        console.warn('[td-upsell] cleanup error', err);
      });
  }

  window.fetch = function () {
    var args = arguments;
    var url = args[0];
    var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
    var isCartMutation = /\/cart\/(change|update|add|clear)\.js/.test(urlStr);

    if (!isCartMutation || cleaning) {
      return origFetch.apply(this, args);
    }

    return origFetch.apply(this, args).then(function (response) {
      var cloned = response.clone();
      cloned.json().then(function (body) {
        var isCart = body && body.items && body.token;
        if (isCart) {
          cleanupFromCart(body);
        } else {
          origFetch.call(window, '/cart.js', { headers: { Accept: 'application/json' }})
            .then(function (r) { return r.json(); })
            .then(cleanupFromCart)
            .catch(function () {});
        }
      }).catch(function () {});
      return response;
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    origFetch.call(window, '/cart.js', { headers: { Accept: 'application/json' }})
      .then(function (r) { return r.json(); })
      .then(function (cart) { cleanupFromCart(cart); })
      .catch(function () {});
  });
})();
